import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-announccment',
  templateUrl: './announccment.component.html',
  styleUrls: ['./announccment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AnnounccmentComponent implements OnInit {
  displayedColumns: string[] = ['no', 'announcement', 'status', 'action'];
  dataSource;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  url = `${environment.apiUrl}/announcement`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialog: MatDialog,
    private http : HttpClient
  ) { }

  ngOnInit() {
    this.getAnnounccment()
  }

  getAnnounccment() {
    this.http.get(this.url, this.httpOptions).subscribe(res => {
      console.log(res['message']);
      this.dataSource = new MatTableDataSource(res['message'])
      this.dataSource.paginator = this.paginator;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  dialog_addAnnouncement(){
    const dialogRef = this.dialog.open(dialog_addAnnouncement, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAnnounccment()
    })
  }

  editAnnouncement(data: any) {
    localStorage.setItem('dataEdit', JSON.stringify(data))
    // console.log(data);
    const dialogRef = this.dialog.open(dialog_edit_announcement, {
      width: '40%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getAnnounccment()
      localStorage.removeItem('dataEdit')
    })
  }

}

@Component({
  selector: 'dialog_addAnnouncement',
  templateUrl: 'dialog_addAnnouncement.html',
  styleUrls: ['announccment.component.scss']
})
export class dialog_addAnnouncement implements OnInit {
  // ceate form add
  formAdd: FormGroup;
  announcementAPI = `${environment.apiUrl}/announcement`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };
  constructor(
    public dialogRef: MatDialogRef<dialog_addAnnouncement>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formAddannouncement() 
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formAddannouncement() {
    this.formAdd = this.formBuilder.group({
      message: ['', Validators.required],
      inUse: [false],
    })
  }

  addAnnouncement() {
    // console.log(this.formAdd.value);
    if (this.formAdd.invalid) return;
    this.http.post(this.announcementAPI, this.formAdd.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Add Announcement success.', 'Done', {
        duration: 10000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Add Announcement fail!.', 'Done', {
        duration: 10000,
      });
    })
  }

}

@Component({
  selector: 'dialog_edit_announcement',
  templateUrl: 'dialog_edit_announcement.html',
  styleUrls: ['announccment.component.scss']
})
export class dialog_edit_announcement implements OnInit {
  data_edit = JSON.parse(localStorage.getItem('dataEdit'))
  // ceate form add
  formEdit: FormGroup;
  announcementAPI = `${environment.apiUrl}/announcement`;

  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };
  constructor(
    public dialogRef: MatDialogRef<dialog_edit_announcement>,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.formEditannouncement() 
  }

  ngOnInit() {
    this.setDataEdit()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formEditannouncement() {
    this.formEdit = this.formBuilder.group({
      announcement_id:[''],
      message: ['', Validators.required],
      inUse: [false],
    })
  }

  setDataEdit() {
    this.formEdit.controls['announcement_id'].setValue(this.data_edit['announcement_id'])
    this.formEdit.controls['message'].setValue(this.data_edit['message'])
    this.formEdit.controls['inUse'].setValue(this.data_edit['inUse'])
  }

  EditAnnouncement() {
    // console.log(this.formAdd.value);
    if (this.formEdit.invalid) return;
    this.http.put(`${this.announcementAPI}?announcement_id=${this.formEdit.value.announcement_id}`, this.formEdit.value, this.httpOptions).subscribe(res => {
      // console.log(res);
      this.onNoClick()
      this._snackBar.open('Edit Announcement success.', 'Done', {
        duration: 10000,
      });
    }, err => {
      console.log(err);
      this._snackBar.open('Edit Announcement fail!.', 'Done', {
        duration: 10000,
      });
    })
  }

}
